import api from './api';

export interface PersonBiometricsRow {
  id: number;
  person_uuid: string;
  first_name: string;
  last_name: string;
  employee_no?: string | null;
  company_name: string;
  is_external_company: 0 | 1;
  is_active: 0 | 1;
  embedding_dim: number;
  embedding_dtype: string;
  model_name: string;
  model_version: string;
  consent_obtained: 0 | 1;
  created_at: string;
  updated_at: string;
}

export interface EnrollResponse {
  success: boolean;
  person_uuid: string;
  created_ids: number[];
  data: PersonBiometricsRow[];
  debug?: any;
}

class BiometricsService {
  async list(limit = 50): Promise<PersonBiometricsRow[]> {
    const { data } = await api.get<{ success: boolean; data: PersonBiometricsRow[] }>(`/biometrics?limit=${limit}`);
    return data.data || [];
  }

  async enroll(payload: {
    person_uuid?: string;
    first_name: string;
    last_name: string;
    employee_no?: string;
    company_name: string;
    is_external_company: boolean;
    is_active: boolean;
    consent_obtained: boolean;
    images: File[];
    metadata?: any;
  }): Promise<EnrollResponse> {
    const form = new FormData();
    if (payload.person_uuid) form.append('person_uuid', payload.person_uuid);
    form.append('first_name', payload.first_name);
    form.append('last_name', payload.last_name);
    if (payload.employee_no) form.append('employee_no', payload.employee_no);
    form.append('company_name', payload.company_name);
    form.append('is_external_company', payload.is_external_company ? '1' : '0');
    form.append('is_active', payload.is_active ? '1' : '0');
    form.append('consent_obtained', payload.consent_obtained ? '1' : '0');
    if (payload.metadata !== undefined) form.append('metadata', JSON.stringify(payload.metadata));

    for (const img of payload.images || []) {
      form.append('images', img);
    }

    const { data } = await api.post<EnrollResponse>('/biometrics/enroll', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    if (!data?.success) throw new Error('Nie udało się dodać danych biometrycznych');
    return data;
  }
}

const biometricsService = new BiometricsService();
export default biometricsService;

